/*
 *
 * ReportHeader actions
 *
 */

import {
  GET_MEDITIONS_FAILED,
  GET_MEDITIONS_SUCCESS,
  GET_MEDITIONS_WATCHER,
  MEDITIONS_ACTIONS_FAILED,
  MEDITIONS_ACTIONS_SUCCESS,
  MEDITIONS_ACTIONS_WATCHER,
  OFFICIALIZE_MEDITIONS_FAILED,
  OFFICIALIZE_MEDITIONS_SUCCESS,
  OFFICIALIZE_MEDITIONS_WATCHER,
  SET_CURRENT_MEDITION,
  GET_SURVEY_TYPES_WATCHER,
  GET_SURVEY_TYPES_FAILED,
  GET_SURVEY_TYPES_SUCCESS,
  GET_MEASURE_WATCHER,
  GET_MEASURE_SUCCESS,
  GET_MEASURE_FAILED,
} from "./constants"


export function getMeasureWatcher (payload) {
  return {
    type: GET_MEASURE_WATCHER,
    payload,
  }
}

export function getMeasureSuccess(payload) {
  return {
    type: GET_MEASURE_SUCCESS,
    payload,
  }
}

export function getMeasureFailed() {
  return { type: GET_MEASURE_FAILED }
}

export function getMeditionsWatcher(payload) {
  return {
    type: GET_MEDITIONS_WATCHER,
    payload,
  }
}

export function getMeditionsSuccess(payload) {
  return {
    type: GET_MEDITIONS_SUCCESS,
    payload,
  }
}

export function getMeditionsFailed() {
  return { type: GET_MEDITIONS_FAILED }
}

export function getSurveyTypesWatcher(payload) {
  return {
    type: GET_SURVEY_TYPES_WATCHER,
    payload,
  }
}

export function getSurveyTypesSuccess(payload) {
  return {
    type: GET_SURVEY_TYPES_SUCCESS,
    payload,
  }
}

export function getSurveyTypesFailed(payload) {
  return {
    type: GET_SURVEY_TYPES_FAILED,
    payload,
  }
}

// officialize
export function officializeWatcher(payload) {
  return {
    type: OFFICIALIZE_MEDITIONS_WATCHER,
    payload,
  }
}

export function officializeSuccess(payload) {
  return {
    type: OFFICIALIZE_MEDITIONS_SUCCESS,
    payload,
  }
}

export function officializeFailed() {
  return { type: OFFICIALIZE_MEDITIONS_FAILED }
}

export function setCurrentMedition(payload) {
  return {
    type: SET_CURRENT_MEDITION,
    payload,
  }
}

export function getMeditionsAvailableActionsWatcher(payload) {
  return {
    type: MEDITIONS_ACTIONS_WATCHER,
    payload,
  }
}

export function getMeditionsAvailableActionsSuccess(payload) {
  return {
    type: MEDITIONS_ACTIONS_SUCCESS,
    payload,
  }
}

export function getMeditionsAvailableActionsFailed() {
  return { type: MEDITIONS_ACTIONS_FAILED }
}
